var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagHc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.7458 33.3945L75.869 18.0867C76.1688 17.3374 76.0772 16.4885 75.6249 15.8204C75.1724 15.1522 74.4181 14.752 73.6113 14.752H42.8105C41.4676 14.752 40.3789 15.8407 40.3789 17.1836V39.0684H34.7051C33.3622 39.0684 32.2734 40.1571 32.2734 41.5V49.6055C32.2734 50.9484 33.3622 52.0371 34.7051 52.0371H73.6113C74.4183 52.0371 75.1724 51.6369 75.6249 50.9686C76.0773 50.3006 76.1688 49.4516 75.869 48.7024L69.7458 33.3945Z",
    fill: "#FC3E6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7046 52.0371C34.3914 52.0371 34.0754 51.9766 33.7746 51.852C32.8659 51.4756 32.2734 50.589 32.2734 49.6055V41.5C32.2734 40.1571 33.3622 39.0684 34.7051 39.0684H42.8106C43.7941 39.0684 44.6808 39.6607 45.0571 40.5695C45.4333 41.4781 45.2253 42.524 44.5299 43.2195L36.4244 51.325C35.9593 51.7902 35.3373 52.0371 34.7046 52.0371Z",
    fill: "#D12657"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8105 6.64648H10.3887C9.04576 6.64648 7.95703 7.73521 7.95703 9.07812V41.5C7.95703 42.8429 9.04576 43.9316 10.3887 43.9316H42.8105C44.1535 43.9316 45.2422 42.8429 45.2422 41.5V9.07812C45.2422 7.73521 44.1535 6.64648 42.8105 6.64648Z",
    fill: "#FD7296"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3887 83C9.04576 83 7.95703 81.9113 7.95703 80.5684V2.43164C7.95703 1.08873 9.04576 0 10.3887 0C11.7316 0 12.8203 1.08873 12.8203 2.43164V80.5684C12.8203 81.9113 11.7316 83 10.3887 83Z",
    fill: "#9BA1A8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagHc);
export default __webpack_public_path__ + "static/media/flagHC.ceff992c514b9efa2f61d665dba92ee8.svg";
export { ForwardRef as ReactComponent };